import { render, staticRenderFns } from "./kpSeedDetail.vue?vue&type=template&id=fe36bf2e&scoped=true&"
import script from "./kpSeedDetail.vue?vue&type=script&lang=tsx&"
export * from "./kpSeedDetail.vue?vue&type=script&lang=tsx&"
import style0 from "./kpSeedDetail.vue?vue&type=style&index=0&id=fe36bf2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe36bf2e",
  null
  
)

export default component.exports